var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCurve(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 79,
    viewBox: "0 0 20 79",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 0L1 70C1 74.4183 4.5818 78 9 78L19.448 78",
    stroke: "#D8DCE3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCurve);
export default __webpack_public_path__ + "static/media/curve.dbe1d57b5a2777488f607f0767c8116b.svg";
export { ForwardRef as ReactComponent };